<mat-card>
  <mat-card-content>

    <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="15px">

      <form fxFlex="50">
        <mat-form-field>
          <input matInput type="text" placeholder="Filter by Company" matInput [formControl]="companyControl" [matAutocomplete]="companyAuto" (focus)="loadFilterCompanyOptions()">
          <button mat-button *ngIf="companyNameFilter || companyControl.value" matSuffix mat-icon-button aria-label="Clear" (click)="onClearCompany()">
            <mat-icon>close</mat-icon>
          </button>
          <mat-autocomplete #companyAuto="matAutocomplete" (optionSelected)="onCompanySelected($event)">

            <mat-option *ngIf="loadingFilterOption; else notLoadingCompanies" disabled>
              <div fxLayout="row" fxLayoutAlign="center center"  fxLayoutGap="5px">
                <mat-progress-spinner diameter="20" mode="indeterminate"></mat-progress-spinner>
                <span>Loading...</span>
              </div>
            </mat-option>

            <ng-template #notLoadingCompanies>
              <mat-option *ngIf="!loadingFilterOption && !(filteredCompanies | async)?.length" disabled>
                No items
              </mat-option>

              <mat-option *ngFor="let company of filteredCompanies | async" [value]="company.name">
                  <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
                    <img class="company-logo" *ngIf="company?.companyLogoUrl" [lazyLoad]="company.companyLogoUrl" [matTooltip]="company.name" />
                    <span [class.default-value]="isDefaultId(company.id)" [innerHtml]="company.name | encodeHtml | highlight: companyControl.value"></span>
                  </div>
              </mat-option>
            </ng-template>

          </mat-autocomplete>
        </mat-form-field>
      </form>

      <form fxFlex="50">
        <mat-form-field>
          <input matInput type="text" placeholder="Filter by Brand" matInput [formControl]="brandControl" [matAutocomplete]="brandAuto" (focus)="loadFilterBrandOptions()">
          <button mat-button *ngIf="brandNameFilter || brandControl.value" matSuffix mat-icon-button aria-label="Clear" (click)="onClearBrand()">
            <mat-icon>close</mat-icon>
          </button>
          <mat-autocomplete #brandAuto="matAutocomplete" (optionSelected)="onBrandSelected($event)" [displayWith]="displayBrandFilterName">

            <mat-option *ngIf="loadingFilterOption; else notLoadingBrands" disabled>
              <div fxLayout="row" fxLayoutAlign="center center"  fxLayoutGap="5px">
                <mat-progress-spinner diameter="20" mode="indeterminate"></mat-progress-spinner>
                <span>Loading...</span>
              </div>
            </mat-option>

            <ng-template #notLoadingBrands>
              <mat-option *ngIf="!(filteredBrands | async)?.length" disabled>
                No items
              </mat-option>

              <mat-option *ngFor="let brand of filteredBrands | async" [value]="brand.id">
                  <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
                    <img class="brand-logo" *ngIf="brand?.brandLogoUrl" [lazyLoad]="brand.brandLogoUrl" [matTooltip]="brand.name" />
                    <span [class.default-value]="isDefaultId(brand.id)" [innerHtml]="brand.name | encodeHtml | highlight: brandControl.value"></span>
                  </div>
              </mat-option>
            </ng-template>

          </mat-autocomplete>
        </mat-form-field>
      </form>

      <form fxFlex="50">
        <mat-form-field>
          <input matInput type="text" placeholder="Filter by Shared Range" matInput [formControl]="productRangeControl" [matAutocomplete]="productRangeAuto" (focus)="loadFilterProductRangeOptions()">
          <button mat-button *ngIf="productRangeNameFilter || productRangeControl.value" matSuffix mat-icon-button aria-label="Clear" (click)="onClearProductRange()">
            <mat-icon>close</mat-icon>
          </button>
          <mat-autocomplete #productRangeAuto="matAutocomplete" (optionSelected)="onProductRangeSelected($event)" [displayWith]="displayRange">

            <mat-option *ngIf="loadingFilterOption; else notLoadingProductRanges" disabled>
              <div fxLayout="row" fxLayoutAlign="center center"  fxLayoutGap="5px">
                <mat-progress-spinner diameter="20" mode="indeterminate"></mat-progress-spinner>
                <span>Loading...</span>
              </div>
            </mat-option>

            <ng-template #notLoadingProductRanges>
              <mat-option *ngIf="!(filteredProductRanges | async)?.length" disabled>
                No items
              </mat-option>

              <mat-option *ngFor="let productRange of filteredProductRanges | async" [value]="productRange">
                  <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
                    <img class="company-logo" *ngIf="productRange?.companyLogoUrl" [lazyLoad]="productRange.companyLogoUrl" [matTooltip]="productRange.companyName" />
                    <span *ngIf="!productRange?.companyLogoUrl">{{ productRange.companyName }}</span>
                    <span [class.default-value]="isDefaultId(productRange.id)" class="text-info" [innerHtml]="productRange.name | encodeHtml | highlight: productRangeControl.value"></span>
                  </div>
              </mat-option>
            </ng-template>

          </mat-autocomplete>
        </mat-form-field>
      </form>
      
    </div>

    <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="15px">

      <form fxFlex="50">
        <mat-form-field>
          <input matInput type="text" placeholder="Filter by Product Classification" matInput [formControl]="productClassificationControl" [matAutocomplete]="productClassificationAuto" (focus)="loadFilterProductClassificationOptions()">
          <button mat-button *ngIf="productClassificationNameFilter || productClassificationControl.value" matSuffix mat-icon-button aria-label="Clear" (click)="onClearProductClassification()">
            <mat-icon>close</mat-icon>
          </button>
          <mat-autocomplete #productClassificationAuto="matAutocomplete" (optionSelected)="onProductClassificationSelected($event)">

            <mat-option *ngIf="loadingFilterOption; else notLoadingProductClassifications" disabled>
              <div fxLayout="row" fxLayoutAlign="center center"  fxLayoutGap="5px">
                <mat-progress-spinner diameter="20" mode="indeterminate"></mat-progress-spinner>
                <span>Loading...</span>
              </div>
            </mat-option>

            <ng-template #notLoadingProductClassifications>
              <mat-option *ngIf="!(filteredProductClassifications | async)?.length" disabled>
                No items
              </mat-option>

              <mat-option *ngFor="let productClassification of filteredProductClassifications | async" [value]="productClassification.name">
                  <div class="w-100" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
                    <span [innerHtml]="productClassification.name | encodeHtml | highlight: productClassificationControl.value"></span>
                  </div>
              </mat-option>
            </ng-template>

          </mat-autocomplete>
        </mat-form-field>
      </form>

      <form fxFlex="50">
        <mat-form-field>
          <input matInput type="text" placeholder="Filter by Product Type" matInput [formControl]="productTypeControl" [matAutocomplete]="productTypeAuto" (focus)="loadFilterProductTypeOptions()">
          <button mat-button *ngIf="productTypeNameFilter || productTypeControl.value" matSuffix mat-icon-button aria-label="Clear" (click)="onClearProductType()">
            <mat-icon>close</mat-icon>
          </button>
          <mat-autocomplete #productTypeAuto="matAutocomplete" (optionSelected)="onProductTypeSelected($event)">

            <mat-option *ngIf="loadingFilterOption; else notLoadingProductTypes" disabled>
              <div fxLayout="row" fxLayoutAlign="center center"  fxLayoutGap="5px">
                <mat-progress-spinner diameter="20" mode="indeterminate"></mat-progress-spinner>
                <span>Loading...</span>
              </div>
            </mat-option>

            <ng-template #notLoadingProductTypes>
              <mat-option *ngIf="!(filteredProductTypes | async)?.length" disabled>
                No items
              </mat-option>

              <mat-option *ngFor="let productType of filteredProductTypes | async" [value]="productType.name">
                  <div class="w-100" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
                    <span [innerHtml]="productType.name | encodeHtml | highlight: productTypeControl.value"></span>
                  </div>
              </mat-option>
            </ng-template>

          </mat-autocomplete>
        </mat-form-field>
      </form>

      <form fxFlex="50">
        <mat-form-field>
          <input matInput type="text" placeholder="Filter by Product State" matInput [formControl]="productStateControl" [matAutocomplete]="productStateAuto" (focus)="loadFilterProductStateOptions()">
          <button mat-button *ngIf="productStateNameFilter || productStateControl.value" matSuffix mat-icon-button aria-label="Clear" (click)="onClearProductState()">
            <mat-icon>close</mat-icon>
          </button>

          <mat-autocomplete #productStateAuto="matAutocomplete" (optionSelected)="onProductStateSelected($event)">

            <mat-option *ngIf="loadingFilterOption; else notLoadingProductStates" disabled>
              <div fxLayout="row" fxLayoutAlign="center center"  fxLayoutGap="5px">
                <mat-progress-spinner diameter="20" mode="indeterminate"></mat-progress-spinner>
                <span>Loading...</span>
              </div>
            </mat-option>

            <ng-template #notLoadingProductStates>
              <mat-option *ngIf="!(filteredProductStates | async)?.length" disabled>
                No items
              </mat-option>

              <mat-option *ngFor="let productState of filteredProductStates | async" [value]="productState.name">
                  <div class="w-100" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
                    <product-workflow-icon id="workflow-state-list-icon"
                      [workflowStateType]="productState.stateType">
                    </product-workflow-icon>
                    <span [innerHtml]="productState.name | encodeHtml | highlight: productStateControl.value"></span>
                  </div>
              </mat-option>
            </ng-template>

          </mat-autocomplete>

        </mat-form-field>
      </form>
      
    </div>

    <mat-form-field class="accent">
      <mat-label>Search Filter</mat-label>
      <input matInput type="text" name="searchTerm"
          [(ngModel)]="searchTerm"
          (keyup.esc)="clearSearchTerm()"
          (change)="searchTermChanged()">
      <button mat-button *ngIf="searchTerm" matSuffix mat-icon-button aria-label="Clear" (click)="clearSearchTerm()">
          <mat-icon>close</mat-icon>
      </button>
    </mat-form-field>

    <div fxLayout="row" fxLayoutGap="15px">
      <button mat-button type="submit" mat-flat-button color="primary" (click)="onSearch()">
        <mat-icon>search</mat-icon> Search
      </button>
      <button mat-button type="submit" mat-flat-button color="primary" (click)="downloadCsv()">
        <mat-icon>file_download</mat-icon> Save as CSV
      </button>
    </div>

  </mat-card-content>
</mat-card>

<mat-card>
  <table mat-table class="resizable-table no-hover-highlight" [dataSource]="products" matSort (matSortChange)="sortData($event)" fxFill>
    <ng-container matColumnDef="select">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let item">
        <div class="product-selector" [ngClass]="{'product-selector-selected': item.editMode}" fxLayout="column" fxLayoutAlign="center center">
          <mat-icon *ngIf="item.editMode" (click)="cancelEditMode(item)" matTooltip="Select Product">check_box</mat-icon>
          <mat-icon *ngIf="!item.editMode" (click)="enableEditMode(item)" matTooltip="Deselect Product">check_box_outline_blank</mat-icon>
        </div>
      </td>

      <td mat-footer-cell *matFooterCellDef>
        <div fxLayout="column" fxLayoutAlign="center center">
          <mat-icon *ngIf="hasEditModeLineItems()" (click)="editAllLineItems(false)" matTooltip="Deselect all Products">deselect</mat-icon>
          <mat-icon *ngIf="!hasEditModeLineItems()" (click)="editAllLineItems(true)" matTooltip="Select all Products">select_all</mat-icon>
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="id">
      <th mat-header-cell *matHeaderCellDef> Product ID </th>
      <td mat-cell *matCellDef="let item"> {{item.product.id}} </td>
      <td mat-footer-cell *matFooterCellDef></td>
    </ng-container>

    <ng-container matColumnDef="company">
      <th mat-header-cell *matHeaderCellDef mat-sort-header appColumnResize> Company <span class="text-info">*</span> </th>
      <td mat-cell *matCellDef="let item">
        <div class="cell">
        
        
          <div class="no-wrap cell-value-readonly" [matTooltip]="companyDirectory[item.product.companyId]">
            {{companyDirectory[item.product.companyId]}}
          </div>
        </div>
      </td>

      <td mat-footer-cell *matFooterCellDef></td>
    </ng-container>

    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef mat-sort-header appColumnResize> Name <span class="text-info">*</span> </th>
      <td mat-cell *matCellDef="let item">
        <div class="cell">

          <div *ngIf="item.editMode">
            <small>
              <mat-error *ngIf="!item.product.name">
                Name is required
              </mat-error>
            </small>
  
            <form class="cell-form">
              <input type="text" class="cell-value-input" [(ngModel)]="item.product.name" [ngModelOptions]="{standalone: true}">
            </form>
          </div>

          <div class="no-wrap cell-value-readonly" *ngIf="!item.editMode" [matTooltip]="item.product.name">
            {{item.product.name}}
          </div>
        </div>
      </td>

      <td mat-footer-cell *matFooterCellDef></td>
    </ng-container>

    <ng-container matColumnDef="sku">
      <th mat-header-cell *matHeaderCellDef mat-sort-header appColumnResize> Product Code </th>
      <td mat-cell *matCellDef="let item">
        <div class="cell">

          <div *ngIf="item.editMode">
            <form class="cell-form">
              <input type="text" class="cell-value-input" [(ngModel)]="item.product.sku" [ngModelOptions]="{standalone: true}">
            </form>
          </div>

          <div class="no-wrap cell-value-readonly" *ngIf="!item.editMode" [matTooltip]="item.product.sku">
            {{item.product.sku}}
          </div>
        </div>
      </td>

      <td mat-footer-cell *matFooterCellDef></td>
    </ng-container>

    <ng-container matColumnDef="productType">
      <th mat-header-cell *matHeaderCellDef mat-sort-header appColumnResize> Product Type <span class="text-info">*</span> </th>
      <td mat-cell *matCellDef="let item">
        <div class="cell">

          <div *ngIf="item.editMode">
            <small>
              <mat-error *ngIf="!item.productTypeControl.value && !item.product.productTypeId">
                Product Type is required
              </mat-error>
              <mat-error *ngIf="item.productTypeControl.value && !item.product.productTypeId">
                Invalid Product Type
              </mat-error>
            </small>

            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
              <form class="cell-form">
                <input type="text" class="cell-value-input" placeholder="Select a Product Type" [formControl]="item.productTypeControl" [matAutocomplete]="productTypeAuto">
                <mat-autocomplete #productTypeAuto="matAutocomplete" panelWidth="250px" (optionSelected)="onLineItemProductTypeSelected($event, item)" (opened)="item.clearProductType()">
                  <mat-option *ngFor="let productType of item.filteredProductTypes | async" [value]="productType.name">
                    <span [innerHtml]="productType.name | encodeHtml | highlight: item.productTypeControl.value"></span>
                  </mat-option>
                </mat-autocomplete>
              </form>

              <mat-icon class="value-icon" color="accent" inline (click)="editSameProductType(item.product.productTypeId, false)" matTooltip="Cancel Editing Products with the same Product Type">deselect</mat-icon>
            </div>

          </div>
        
          <div *ngIf="!item.editMode" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
            <div class="no-wrap cell-value-readonly" [matTooltip]="getProductTypeName(item.product)">
              {{getProductTypeName(item.product)}}
            </div>
            <mat-icon class="value-icon" color="accent" inline (click)="editSameProductType(item.product.productTypeId, true)" matTooltip="Edit Products with the same Product Type">select_all</mat-icon>
          </div>

        </div>
      </td>

      <td mat-footer-cell *matFooterCellDef>
        <div class="cell" *ngIf="hasEditModeLineItems()">
          <span>
            Bulk Set Product Type:
          </span>

          <form class="cell-form">
            <input type="text" class="cell-value-input" placeholder="Select a Product Type" [formControl]="bulkProductTypeControl" [matAutocomplete]="productTypeAuto">
            <mat-autocomplete #productTypeAuto="matAutocomplete" panelWidth="250px" (optionSelected)="onBulkProductTypeSelected($event)" (opened)="clearBulkProductType()">
              <mat-option *ngFor="let productType of filteredBulkProductTypes | async" [value]="productType.name">
                <span [innerHtml]="productType.name | encodeHtml | highlight: bulkProductTypeControl.value"></span>
              </mat-option>
            </mat-autocomplete>
          </form>
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="productSpecification">
      <th mat-header-cell *matHeaderCellDef appColumnResize> Product Specifications </th>
      <td mat-cell *matCellDef="let item">
        <div class="cell">

          <div *ngIf="item.editMode" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
            <div class="no-wrap cell-value-readonly" [matTooltip]="getProductSpecificationString(item.product)">
              {{getProductSpecificationString(item.product)}}
            </div>

            <button mat-icon-button matTooltip="Edit Product Specifications." [disabled]="!canEditProductSpecifications(item)" (click)="onOpenProductSpecificationDialog(item)">
              <mat-icon>edit</mat-icon>
            </button>
            
            <mat-icon class="value-icon" color="accent" inline (click)="editSameProductSpecification(item.product.productSpecificationIds, false)" matTooltip="Cancel Editing Products with the same Product Specifications">deselect</mat-icon>
          </div>
        
          <div *ngIf="!item.editMode" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
            <div class="no-wrap cell-value-readonly" [matTooltip]="getProductSpecificationString(item.product)">
              {{getProductSpecificationString(item.product)}}
            </div>
            <mat-icon class="value-icon" color="accent" inline (click)="editSameProductSpecification(item.product.productSpecificationIds, true)" matTooltip="Edit Products with the same Product Specifications">select_all</mat-icon>
          </div>

        </div>
      </td>

      <td mat-footer-cell *matFooterCellDef>
        <div class="cell" *ngIf="hasEditModeLineItems()">
          <span>
            Bulk Set Product Specifications:
          </span>

          <div fxLayout="row" fxLayoutAlign="center center">
            <button mat-icon-button matTooltip="Edit Product Specifications." [disabled]="!canBulkEditProductSpecifications()" (click)="onBulkOpenProductSpecificationDialog()">
              <mat-icon>edit</mat-icon>
            </button>
          </div>
          
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="description">
      <th mat-header-cell *matHeaderCellDef appColumnResize> Description </th>
      <td mat-cell *matCellDef="let item">
        <div class="cell">

          <div *ngIf="item.editMode" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
            <form class="cell-form">
              <textarea  class="cell-value-input" [(ngModel)]="item.product.description" [ngModelOptions]="{standalone: true}"></textarea>
            </form>

            <mat-icon class="value-icon" color="accent" inline (click)="editSameDescription(item.product.description, false)" matTooltip="Cancel Editing Products with the same Description">deselect</mat-icon>
          </div>
        
          <div *ngIf="!item.editMode" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
            <div class="two-line-wrap cell-value-readonly" [matTooltip]="item.product.description">
              {{item.product.description}}
            </div>
            <mat-icon class="value-icon" color="accent" inline (click)="editSameDescription(item.product.description, true)" matTooltip="Edit Products with the same Description">select_all</mat-icon>
          </div>
        </div>
      </td>

      <td mat-footer-cell *matFooterCellDef>
        <div class="cell" *ngIf="hasEditModeLineItems()">
          <span>
            Bulk Set Description:
          </span>

          <form class="cell-form">
            <input type="text" class="cell-value-input" (input)="onBulkDescriptionChanged($event)" [ngModelOptions]="{standalone: true}">
          </form>
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="brand">
      <th mat-header-cell *matHeaderCellDef mat-sort-header appColumnResize> Brand </th>
      <td mat-cell *matCellDef="let item">
        <div class="cell">
    
          <div *ngIf="item.editMode" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="5px">
            <small>
              <mat-error *ngIf="item.brandControl.value && !item.product.brandId">
                Invalid Brand
              </mat-error>
            </small>
    
            <form class="cell-form">
              <input type="text" class="cell-value-input" placeholder="Select a Brand" [formControl]="item.brandControl"
                [matAutocomplete]="brandAuto">
              <mat-autocomplete #brandAuto="matAutocomplete" (optionSelected)="onLineItemBrandSelected($event, item)"
                (opened)="item.clearBrand()" [displayWith]="displayBrandName">
                <small>Showing Brands for <em>{{companyDirectory[item.product.companyId]}}</em></small>
                <mat-option [value]="null"><span>None</span></mat-option>
                <mat-option *ngFor="let brand of item.filteredBrands | async" [value]="brand.id">
                  <span [innerHtml]="brand.name | encodeHtml | highlight: item.brandControl.value"></span>
                </mat-option>
              </mat-autocomplete>
            </form>
    
            <mat-icon class="value-icon" color="accent" inline (click)="editSameBrand(item.product.brandId, false)"
              matTooltip="Cancel Editing Products with the same Brand">deselect</mat-icon>
          </div>
    
          <div *ngIf="!item.editMode" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
            <div class="no-wrap cell-value-readonly" [matTooltip]="brandDirectory[item.product.brandId]">
              {{ brandDirectory[item.product.brandId] }}
            </div>
            <mat-icon class="value-icon" color="accent" inline (click)="editSameBrand(item.product.brandId, true)"
            matTooltip="Edit Products with the same Brand">select_all</mat-icon>
          </div>
        </div>
      </td>
    
      <td mat-footer-cell *matFooterCellDef>
        <div class="cell" *ngIf="hasEditModeLineItems()">
          <span>
            Bulk Set Brand:
          </span>
    
          <form class="cell-form">
            <input type="text" class="cell-value-input" placeholder="Select a Brand" [formControl]="bulkBrandControl"
              [matAutocomplete]="bulkBrandAuto">
            <mat-autocomplete #bulkBrandAuto="matAutocomplete" (optionSelected)="onBulkBrandSelected($event)"
              (opened)="clearBulkBrand()" [displayWith]="displayBrandName">
              <mat-option [value]="null">None</mat-option>
              <mat-option *ngFor="let brand of filteredBulkBrands | async" [value]="brand.id">
                <span [innerHtml]="brand.name | encodeHtml | highlight: bulkBrandControl.value"></span>
              </mat-option>
            </mat-autocomplete>
          </form>
        </div>
      </td>
    </ng-container>
    
    <ng-container matColumnDef="qualityLevel">
      <th mat-header-cell *matHeaderCellDef mat-sort-header appColumnResize> Quality Level </th>
      <td mat-cell *matCellDef="let item">
        <div class="cell">
          <div *ngIf="item.editMode" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
            <form class="cell-form">
              <select class="cell-value-input" [ngModel]="item.product.qualityLevel"
                (change)="item.product.qualityLevel = Number($event.target.value)" [ngModelOptions]="{standalone: true}"
                ariaPlaceholder="Select a Quality Level">
                <option [value]="null">None</option>
                <ng-container *ngFor="let quality of QualityLevel | enumKeyValue">
                  <option mat-option [value]="quality.value">{{quality.key}}</option>
                </ng-container>
              </select>
            </form>
    
            <mat-icon class="value-icon" color="accent" inline
              (click)="editSameQualityLevel(item.product.qualityLevel, false)"
              matTooltip="Cancel Editing Products with the same Quality level">deselect</mat-icon>
          </div>
    
          <div *ngIf="!item.editMode" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
            <div class="no-wrap cell-value-readonly"
              [matTooltip]=" 'Quality' + (!item.product.qualityLevel ? ' inherited from Brand' : '') ">
              <ng-container *ngIf="item.product.qualityLevel">
                <span>{{ QualityLevel[item.product.qualityLevel] }}</span>
              </ng-container>
              <ng-container *ngIf="!item.product.qualityLevel && item.product.brand?.qualityLevel">
                <span class="inherited-quality">*{{ QualityLevel[item.product.brand.qualityLevel]}}</span>
              </ng-container>
            </div>
            <mat-icon class="value-icon" color="accent" inline
            (click)="editSameQualityLevel(item.product.qualityLevel, true)"
            matTooltip="Edit Products with the same Quality Level">select_all</mat-icon>
          </div>
        </div>
      </td>
    
      <td mat-footer-cell *matFooterCellDef>
        <div class="cell" *ngIf="hasEditModeLineItems()">
          <span>
            Bulk Set Quality Level:
          </span>
    
          <form class="cell-form">
            <select class="cell-value-input" (change)="onBulkQualityLevelChanged($event)"
              ariaPlaceholder="Select a Quality Level">
              <option [value]="null">None</option>
              <ng-container *ngFor="let quality of QualityLevel | enumKeyValue">
                <option [value]="quality.value">{{quality.key}}</option>
              </ng-container>
            </select>
          </form>
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="state">
      <th mat-header-cell *matHeaderCellDef mat-sort-header appColumnResize> Current Workflow State </th>
      <td mat-cell *matCellDef="let item">
        <div class="cell">

          <div class="cell">
            <small></small>
  
            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
              <product-workflow-icon id="current-workflow-state-icon"
                [workflowStateType]="item.product.currentWorkflowState.stateType">
              </product-workflow-icon>

              <span>
                {{getWorkflowState(item.product)}}
              </span>
              <button mat-icon-button matTooltip="Open product transition dialog." (click)="onOpenWorkflowDialog(item)">
                <mat-icon class="change-state-icon">alt_route</mat-icon>
              </button>
              <mat-icon *ngIf="!item.editMode" class="value-icon" color="accent" inline (click)="editSameProductWorkflowState(item.product.currentWorkflowState!.state, true)" matTooltip="Edit Products in the same Product Workflow State">select_all</mat-icon>
              <mat-icon *ngIf="item.editMode" class="value-icon" color="accent" inline (click)="editSameProductWorkflowState(item.product.currentWorkflowState!.state, false)" matTooltip="Cancel Editing Products in the same Product Workflow State">deselect</mat-icon>
            </div>
          </div>

        </div>
      </td>

      <td mat-footer-cell *matFooterCellDef>
        
        <div class="cell" *ngIf="hasEditModeLineItems()">
          <span>
            Bulk Workflow Transistion:
          </span>

          <div fxLayout="row" fxLayoutAlign="center center">
            <button mat-icon-button matTooltip="Open product transition dialog." [disabled]="!workflowStateOfProductsInEditModeAreTheSame()" (click)="onBulkOpenWorkflowDialog()">
              <mat-icon class="change-state-icon">alt_route</mat-icon>
            </button>
          </div>
        </div>
        
      </td>
    </ng-container>

    <ng-container matColumnDef="notes">
      <th mat-header-cell *matHeaderCellDef appColumnResize> Notes </th>
      <td mat-cell *matCellDef="let item">
        <div class="cell">

          <div *ngIf="item.editMode" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
            <form class="cell-form">
              <textarea class="three-line-wrap cell-value-input" [(ngModel)]="item.product.notes" [ngModelOptions]="{standalone: true}"></textarea>
            </form>

            <mat-icon class="value-icon" color="accent" inline (click)="editSameNotes(item.product.notes, false)" matTooltip="Cancel Editing Products with the same Notes">deselect</mat-icon>
          </div>
        
          <div *ngIf="!item.editMode" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
            <div class="three-line-wrap cell-value-readonly" [matTooltip]="item.product.notes">
              {{item.product.notes}}
            </div>
            <mat-icon class="value-icon" color="accent" inline (click)="editSameNotes(item.product.notes, true)" matTooltip="Edit Products with the same Notes">select_all</mat-icon>
          </div>
        </div>
      </td>

      <td mat-footer-cell *matFooterCellDef>
        <div class="cell" *ngIf="hasEditModeLineItems()">
          <span>
            Bulk Set Notes:
          </span>

          <form class="cell-form">
            <input type="text" class="cell-value-input" (input)="onBulkNotesChanged($event)" [ngModelOptions]="{standalone: true}">
          </form>
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="calloutsEnabled">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Callouts Enabled </th>
      <td mat-cell *matCellDef="let item">
        <div class="cell">

          <div *ngIf="item.editMode" fxLayout="row" fxLayoutAlign="space-evenly center" fxLayoutGap="5px">
            <div></div>
            <button mat-icon-button *ngIf="item.product.calloutsEnabled" [matTooltip]="item.product.calloutsEnabled" (click)="item.product.calloutsEnabled = false">
              <mat-icon>check_box</mat-icon>
            </button>
            <button mat-icon-button *ngIf="!item.product.calloutsEnabled" [matTooltip]="item.product.calloutsEnabled" (click)="item.product.calloutsEnabled = true">
              <mat-icon>check_box_outline_blank</mat-icon>
            </button>

            <mat-icon class="value-icon" color="accent" inline (click)="editSameCalloutsEnabled(item.product.calloutsEnabled, false)" matTooltip="Cancel Editing Products with the same Callouts Enabled state">deselect</mat-icon>
          </div>
        
          <div *ngIf="!item.editMode" fxLayout="row" fxLayoutAlign="space-evenly center" fxLayoutGap="5px">
            <div></div>
            <mat-icon *ngIf="item.product.calloutsEnabled" [matTooltip]="item.product.calloutsEnabled">check</mat-icon>
            <mat-icon *ngIf="!item.product.calloutsEnabled" [matTooltip]="item.product.calloutsEnabled">close</mat-icon>
            <mat-icon class="value-icon" color="accent" inline (click)="editSameCalloutsEnabled(item.product.calloutsEnabled, true)" matTooltip="Edit Products with the same Callouts Enabled state">select_all</mat-icon>
          </div>
        </div>
      </td>

      <td mat-footer-cell *matFooterCellDef>
        <div class="cell" *ngIf="hasEditModeLineItems()">
          <span>
            Bulk Set Callouts Enabled:
          </span>

          <div fxLayout="column" fxLayoutAlign="center center">
            <button mat-icon-button *ngIf="bulkCalloutsEnabled === true" [matTooltip]="bulkCalloutsEnabled" (click)="onBulkCalloutsEnabledChanged(false)">
              <mat-icon>check_box</mat-icon>
            </button>
            <button mat-icon-button *ngIf="bulkCalloutsEnabled === false" [matTooltip]="bulkCalloutsEnabled" (click)="onBulkCalloutsEnabledChanged(true)">
              <mat-icon>check_box_outline_blank</mat-icon>
            </button>
            <button mat-icon-button *ngIf="bulkCalloutsEnabled === undefined" [matTooltip]="bulkCalloutsEnabled" (click)="onBulkCalloutsEnabledChanged(true)">
              <mat-icon>indeterminate_check_box</mat-icon>
            </button>
          </div>
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="hideSku">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Hide Product Code </th>
      <td mat-cell *matCellDef="let item">
        <div class="cell">

          <div *ngIf="item.editMode" fxLayout="row" fxLayoutAlign="space-evenly center" fxLayoutGap="5px">
            <div></div>
            <button mat-icon-button *ngIf="item.product.hideSku" [matTooltip]="item.product.hideSku" (click)="item.product.hideSku = false">
              <mat-icon>check_box</mat-icon>
            </button>
            <button mat-icon-button *ngIf="!item.product.hideSku" [matTooltip]="item.product.hideSku" (click)="item.product.hideSku = true">
              <mat-icon>check_box_outline_blank</mat-icon>
            </button>

            <mat-icon class="value-icon" color="accent" inline (click)="editSameHideSku(item.product.hideSku, false)" matTooltip="Cancel Editing Products with the same Hide Product Code state">deselect</mat-icon>
          </div>
        
          <div *ngIf="!item.editMode" fxLayout="row" fxLayoutAlign="space-evenly center" fxLayoutGap="5px">
            <div></div>
            <mat-icon *ngIf="item.product.hideSku" [matTooltip]="item.product.hideSku">check</mat-icon>
            <mat-icon *ngIf="!item.product.hideSku" [matTooltip]="item.product.hideSku">close</mat-icon>
            <mat-icon class="value-icon" color="accent" inline (click)="editSameHideSku(item.product.hideSku, true)" matTooltip="Edit Products with the same Hide Product Code state">select_all</mat-icon>
          </div>
        </div>
      </td>

      <td mat-footer-cell *matFooterCellDef>
        <div class="cell" *ngIf="hasEditModeLineItems()">
          <span>
            Bulk Set Hide Product Code:
          </span>

          <div fxLayout="column" fxLayoutAlign="center center">
            <button mat-icon-button *ngIf="bulkHideProductCode === true" [matTooltip]="bulkHideProductCode" (click)="onBulkHideProductCodeChanged(false)">
              <mat-icon>check_box</mat-icon>
            </button>
            <button mat-icon-button *ngIf="bulkHideProductCode === false" [matTooltip]="bulkHideProductCode" (click)="onBulkHideProductCodeChanged(true)">
              <mat-icon>check_box_outline_blank</mat-icon>
            </button>
            <button mat-icon-button *ngIf="bulkHideProductCode === undefined" [matTooltip]="bulkHideProductCode" (click)="onBulkHideProductCodeChanged(true)">
              <mat-icon>indeterminate_check_box</mat-icon>
            </button>
          </div>
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="enabled">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Product Enabled </th>
      <td mat-cell *matCellDef="let item">
        <div class="cell">

          <div *ngIf="item.editMode" fxLayout="row" fxLayoutAlign="space-evenly center" fxLayoutGap="5px">
            <div></div>
            <button mat-icon-button *ngIf="!item.product.disabled" [matTooltip]="!item.product.disabled" (click)="item.product.disabled = true">
              <mat-icon>check_box</mat-icon>
            </button>
            <button mat-icon-button *ngIf="item.product.disabled" [matTooltip]="!item.product.disabled" (click)="item.product.disabled = false">
              <mat-icon>check_box_outline_blank</mat-icon>
            </button>

            <mat-icon class="value-icon" color="accent" inline (click)="editSameProductDisabled(item.product.disabled, false)" matTooltip="Cancel Editing Products with the same Enabled state">deselect</mat-icon>
          </div>
        
          <div *ngIf="!item.editMode" fxLayout="row" fxLayoutAlign="space-evenly center" fxLayoutGap="5px">
            <div></div>
            <mat-icon *ngIf="!item.product.disabled" [matTooltip]="!item.product.disabled">check</mat-icon>
            <mat-icon *ngIf="item.product.disabled" [matTooltip]="!item.product.disabled">close</mat-icon>
            <mat-icon class="value-icon" color="accent" inline (click)="editSameProductDisabled(item.product.disabled, true)" matTooltip="Edit Products with the same Enabled state">select_all</mat-icon>
          </div>
        </div>
      </td>

      <td mat-footer-cell *matFooterCellDef>
        <div class="cell" *ngIf="hasEditModeLineItems()">
          <span>
            Bulk Set Product Enabled:
          </span>

          <div fxLayout="column" fxLayoutAlign="center center">
            <button mat-icon-button *ngIf="bulkProductEnabled === true" [matTooltip]="bulkProductEnabled" (click)="onBulkProductEnabledChanged(false)">
              <mat-icon>check_box</mat-icon>
            </button>
            <button mat-icon-button *ngIf="bulkProductEnabled === false" [matTooltip]="bulkProductEnabled" (click)="onBulkProductEnabledChanged(true)">
              <mat-icon>check_box_outline_blank</mat-icon>
            </button>
            <button mat-icon-button *ngIf="bulkProductEnabled === undefined" [matTooltip]="bulkProductEnabled" (click)="onBulkProductEnabledChanged(true)">
              <mat-icon>indeterminate_check_box</mat-icon>
            </button>
          </div>
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="edit">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let item">

        <div *ngIf="item.editMode" fxLayout="row" fxLayoutAlign="center center">
          <button mat-icon-button color="accent" matTooltip="Save Product" (click)="onSaveLineItem(item)">
            <mat-icon>save</mat-icon>
          </button>
          <button mat-icon-button color="accent" matTooltip="Cancel Editing Product" (click)="cancelEditMode(item)">
            <mat-icon>close</mat-icon>
          </button>
        </div>

        <div *ngIf="!item.editMode" fxLayout="row" fxLayoutAlign="center center">
          <a routerLink="/products/{{ item.product.id }}" routerLinkActive="active" target="_blank">
            <mat-icon class="link" color="accent" matTooltip="Edit Product">kitchen</mat-icon>
          </a>
        </div>
      </td>

      <td mat-footer-cell *matFooterCellDef>
        <div fxLayout="row" fxLayoutAlign="center center">
          <button *ngIf="hasEditModeLineItems()" mat-icon-button color="accent" matTooltip="Save All Products" (click)="onSaveAllEditModeLineItems()">
            <mat-icon>save</mat-icon>
          </button>
          <button *ngIf="hasEditModeLineItems()"mat-icon-button color="accent" matTooltip="Cancel Editing All Product" (click)="editAllLineItems(false)">
            <mat-icon>close</mat-icon>
          </button>
        </div>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    <tr mat-footer-row *matFooterRowDef="displayedColumns; sticky: true"></tr>
  </table>

  <div fxLayout="row" fxLayoutAlign="space-between center">
    <div class="p-l-20">
      <span>Selected Count: {{countEditModeLineItems()}}</span>
    </div>
    <mat-paginator #paginator [length]="totalItems" [pageSize]="pageSize" [pageSizeOptions]="[100, 250, 500]" (page)="onPageChange($event)">
    </mat-paginator>
  </div>
</mat-card>